module.exports = __webpack_public_path__ + "img/section3-shadow-bottom.597b9330.png";